import { WeldVerticesFeature } from '@kb3d/models/classes/features/weld-vertices-feature';
import { Token } from '@kb3d/models/classes/token';
import { FeatureRenderer } from './feature';
import { WeldVerticesGeometryProcessor } from './geometry-processor/weld-vertices-geometry';

export class WeldVerticesRenderer extends FeatureRenderer<WeldVerticesFeature> {
    modelToken = Token.WeldVerticesFeature;
    processor = new WeldVerticesGeometryProcessor(this.scene);

    update3dInternal() {}
}
